import React from 'react'
import "./Footer.css"
import FooterSVG from '../SVG Pics/FooterSVG'
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";




function Footer() {
  return (
    <div>
        <div className='container-fluid footer-div1'>
            <div className='footer-svg-1'></div>
            <div className='footer-svg-2'></div>

            <div className='container'>
                <div className='row'>
                    <div className='col-lg-4 col-12 '>
                          <p className='footer-para1'>Interested in working with us?</p>
                          <h1 className='footer-head1'>Let’s Connect</h1>
                        <div className='footer-btn-div1 mx-lg-0 mx-auto'>
                            <Link to="/contact-us" className='footer-btn1 '>Tell Us Everything</Link>
                        </div>
                    </div>
                    <div className='col-lg-8 col-12 footer-links-div'>
                        <div className='row'>
                        <div className='col-sm-4 col-12'>
                            <p className='footer-para2'><Link to="/about-us" className='footer-para2'>About Us</Link></p>
                            <p className='footer-para2'><Link to="/career" className='footer-para2'>Career</Link></p>
                            <p className='footer-para2'><HashLink spy={true}
                  smooth={true}
                  offset={-100}
                  duration={600} to="/#our-work" className='footer-para2'>Our Work</HashLink></p>
                        </div>
                        <div className='col-sm-4 col-12'>
                            <p className='footer-para2'>Term & Condition</p>
                            <p className='footer-para2'>Privacy Policy</p>
                        </div>
                        <div className='col-sm-4 col-12'>
                            <p className='footer-para2'>LinkedIn</p>
                            <p className='footer-para2'>Instagram</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

           <div className="d-flex justify-content-center">
            <p className="footer-para3">© 2023 Digital Marketing Agency - BrainSouls</p>
           </div>
        </div>
    </div>
  )
}

export default Footer